export default __webpack_public_path__ + "maps-examples-simple-map-view-960-d1ab578418bdd113849d65d31e5c9aab.png";